<mat-card class="cardWithShadow">
    <mat-card-content>
        <div *ngIf="dataSource && dataSource.data.length > 0"
         class="table-responsive m-t-30">
            <table mat-table
            [dataSource]="dataSource"
            matSort
            matSortDirection="desc"
            matSortActive="financedAmount">
                <!-- Columna de folio -->
                <ng-container matColumnDef="folio">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Folio
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.folio }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="debtorRut">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Rut Deudor
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.debtorRut }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="debtorName">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Nombre deudor
                    </th>
                    <td mat-cell *matCellDef="let element" >
                        <h6>{{ element.debtorName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="invoiceTotalAmount">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Monto Factura
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.invoiceTotalAmount | number }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="financedAmount">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Financiado
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.financedAmount | number }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Tasa
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.rate | number }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="allInRate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Tasa Total
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.allInRate | number }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="operationState">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.operationState }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="plazo">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Plazo
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>{{ element.plazo | number}}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="comment">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Comentario
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6 matTooltip="{{element.comment}}">{{ element.comment }}</h6>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedCols"></tr>
                <tr mat-row class="cursor-row" [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayedCols">
                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z8">
                            <button 
                                cdkMenuItem 
                                class="menu-item" 
                                (click)="selectOperationToUpdate(row)" 
                                mat-raised-button>
                                Recotizar
                            </button>
                        </div>
                    </ng-template>
                </tr>
            </table>
        </div>
        <span *ngIf="!dataSource || dataSource.data.length == 0">
            <h3>Sin operaciones a evaluar</h3>
        </span>

        <h3 style="margin-top: 30px;" *ngIf="dataSourceOrder && dataSourceOrder.data.length > 0">Ordenes Asociadas</h3>

        <div class="table-responsive m-t-30" *ngIf="dataSourceOrder && dataSourceOrder.data.length > 0">
            <table mat-table
            [dataSource]="dataSourceOrder">

                <ng-container matColumnDef="folio">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Folio
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6> {{ element?.folio ? element.folio : "Sin Ordenes" }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Code
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>
                            {{                             
                                element?.code
                                ? element.code 
                                : "Sin Ordenes" 
                            }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>
                            {{
                            element?.amount
                            ? (element.amount | currency:'CLP':'symbol')
                            : "Sin Ordenes"
                            }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaEmision">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Fecha Emision
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>
                            {{
                            element?.fechaEmision
                            ? (element.fechaEmision | date : "dd-MM-yyyy")
                            : "Sin Ordenes"
                            }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="plazo">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Plazo
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>
                            {{
                            element?.plazo
                            ? element.plazo
                            : "Sin Ordenes"
                            }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sigfe">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        SIGFE
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <h6>
                            {{
                            element?.sigfe
                            ? element.sigfe
                            : "Sin Ordenes"
                            }}
                        </h6>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColsOrder"></tr>
                <tr mat-row class="cursor_table" *matRowDef="let row; columns: displayedColsOrder"></tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>